import React, { FC } from 'react';
import { DatePicker, DatePickerProps } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { getDateFormat, SystemLocales } from '~src/interfaces/session.types';
import { StoreI } from '~src/rootReducer';
import { getSystemLocale } from '~src/services/session';

import { DatePickerContainerWrapper } from './inputs.sc';
import InputLabelWrapper from './InputLabelWrapper';
import { useTranslation } from 'react-i18next';

interface Props {
  allowClear?: boolean;
  error?: string;
  dateValue: string | moment.Moment | null;
  defaultValue?: string;
  onChange?: (date: moment.Moment | null, dateString: string) => void;
  className?: string;
  label: string;
  labelKey: string;
  datePickerOptions?: DatePickerProps;
}

interface StateProps {
  systemLocale: SystemLocales;
}

const CustomDatePicker: FC<Props & StateProps> = React.memo((props) => {
  const [t] = useTranslation();

  return (
    <InputLabelWrapper
      insideForm
      valid={!props.error}
      hasValue={!!props.defaultValue || !!props.dateValue}
      error={props.error}
      label={props.label}
      labelKey={props.labelKey}
    >
      <DatePickerContainerWrapper $valid={!props.error}>
        <DatePicker
          allowClear={props.allowClear === undefined ? true : props.allowClear}
          className={props.className}
          value={props.dateValue ? moment(props.dateValue) : undefined}
          onChange={props.onChange}
          placeholder={t('x.date.placeholderValue')}
          format={getDateFormat(props.systemLocale)}
          showToday={false}
          {...(props.datePickerOptions ? props.datePickerOptions : {})}
        />
      </DatePickerContainerWrapper>
    </InputLabelWrapper>
  );
});

const mapStateToProps = (state: StoreI): StateProps => ({
  systemLocale: getSystemLocale(state),
});

const CustomDatePickerConnected = connect(mapStateToProps)(CustomDatePicker);

export default CustomDatePickerConnected;
